import { COUNTRIES } from './countries'
import { getDateAndNumberByCountry } from 'utils/date'

export const NUMBER_EXAMPLE = 12345.67

export const DATE_FORMATS = () => ({
  [COUNTRIES.AU]: new Intl.DateTimeFormat('en-AU')
})

export const COUNTRY_FORMATS = (options) => ({
  [COUNTRIES.AU]: new Intl.NumberFormat('en-AU', options)
})

export const getDateTimeFormatOptions = () => [
  {
    value: COUNTRIES.AU,
    label: `${COUNTRIES.AU} (${getDateAndNumberByCountry(COUNTRIES.AU)})`
  }
]

export const DAYS = {
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday'
}

export const BUSINESS_DAYS_OPTIONS = [
  { value: DAYS.MONDAY, label: 'Monday' },
  { value: DAYS.TUESDAY, label: 'Tuesday' },
  { value: DAYS.WEDNESDAY, label: 'Wednesday' },
  { value: DAYS.THURSDAY, label: 'Thursday' },
  { value: DAYS.FRIDAY, label: 'Friday' },
  { value: DAYS.SATURDAY, label: 'Saturday' },
  { value: DAYS.SUNDAY, label: 'Sunday' }
]
